import React from 'react';

import { Box, Skeleton, Stack, Typography } from '@mui/material';

import { Company, CompanyDetails } from '../types';
import SocialIconsContainer from 'components/SocialIconsContainer';

type Props = {
  company: Company | null;
  companyDetails: CompanyDetails | null;
  loadingDetails: boolean;
};

export const CompanyInfo: React.FC<Props> = ({ company, companyDetails, loadingDetails }) => {
  const socialNetworks = companyDetails?.social_networks || [];

  if (loadingDetails) {
    return (
      <Stack
        direction="column"
        spacing={1}
        justifyContent="center"
        alignItems="start"
        height="100%"
      >
        <Skeleton variant="rectangular" width="75%" height={45} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rectangular" width="50%" height={35} sx={{ borderRadius: 1 }} />
      </Stack>
    );
  }

  if (!company) return null;

  return (
    <Stack direction="column" spacing={0} justifyContent="center" alignItems="start" height="100%">
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="h3" fontWeight={600} color="primary">
          {company.name}
        </Typography>
      </Stack>

      <Box my={0.8}>
        <Stack
          direction="column"
          spacing={1}
          alignItems="center"
          justifyContent="center"
          height="100%"
        >
          <Box mt={2}>
            {socialNetworks && socialNetworks.length > 0 && (
              <SocialIconsContainer
                socialNetworks={socialNetworks}
                socialLoading={false}
                socialError={null}
                circle
                iconSize={16}
              />
            )}
          </Box>
        </Stack>
      </Box>
    </Stack>
  );
};
